
import Browser from './browser.js'

function uint2int (num) {
    if (num > 0xff / 2) {
      var a = ~0xff;
      num = num | a;
    }
    return num;
  }

function clamp(num, a, b) {
    return Math.max(Math.min(num, Math.max(a, b)), Math.min(a, b));
}

//浏览器播放声音时，传递的切片里采样个数要求是2的倍数，根据采样率选择一个合适的采样切片数
function caculateSamplesPerPacket(sampleRate) {

    return 1024;

}

function createWorkletModuleUrl(func) {

    function functionToString(str) {
        return str.trim().match(/^function\s*\w*\s*\([\w\s,]*\)\s*{([\w\W]*?)}$/)[1]
    }

    const funcStr = functionToString(func.toString());
    const blob = new Blob([funcStr], {type: 'application/javascript'});
    return URL.createObjectURL(blob);
}


function supportOffScreenCanvas() {

    return !!self.OffscreenCanvas
   
}

function supportWebCodecs() {

    return !!self.VideoDecoder
   
}

function supportSIMD() {

    return WebAssembly.validate(new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 5, 1, 96, 0, 1, 123, 3, 2, 1, 0, 10, 10, 1, 8, 0, 65, 0, 253, 15, 253, 98, 11]));

}


function supportShareArrayBuffer() {

    return !!self.SharedArrayBuffer 
   
}

function supportMSE() {

    return self.MediaSource ? true : false;
}

function supportMSEForWorker() {

    return (self.Worker &&
        self.MediaSource &&
        ('canConstructInDedicatedWorker' in self.MediaSource) &&
        self.MediaSource['canConstructInDedicatedWorker'] === true) ? true : false;


}

function GenRandomString(strlen = 32) {
    let str = 'abcdefghijklmnopqrstuvwxyz0123456789';    
    let pwd = '';
    for (let i = 0; i < strlen; i++) {
    pwd += str.charAt(Math.floor(Math.random() * str.length));
    }

    return pwd
}

function isDefaultColorOptions(options) {

    if (options.brightness != 1.0) {
        
        return false
    }

    if (options.contrast != 1.0) {
        
        return false
    }

    if (options.saturate != 1.0) {
        
        return false
    }

    if (options.huerotate != 0) {
        
        return false
    }

    return true

}


export { uint2int, clamp, caculateSamplesPerPacket, createWorkletModuleUrl,supportOffScreenCanvas,supportMSE,supportMSEForWorker,supportWebCodecs, supportShareArrayBuffer, GenRandomString, isDefaultColorOptions, supportSIMD };